<template>
	<div>
		<!-- 店铺详情 -->
		<cube-page title="免责申明和服务协议">
			<div slot="content">
				<div class="main">
					<van-tabs v-model="activeName" @click="onClick" sticky>
						<van-tab v-for="(item, index) in tabs" :title="item.title" :key="index" :name="item.name">
							<div v-if="content">
								<div class="content" :class="content.content ? 'yes':'no'" v-html="content.content || '暂无内容'"></div>
								<!-- <div class="down" v-if="content.image" @click="downloadPdf">
									<van-button plain type="info" block>协议下载</van-button>
								</div> -->
								<div class="down agreement" @click="agreement">
									<van-button type="primary" block>已阅读并且同意协议</van-button>
								</div>
							</div>
							<div v-else class="empty">
								<van-empty image="error" description="暂无协议" />
							</div>
						</van-tab>
					</van-tabs>
				</div>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from "@/utils/network";
  import {redirect} from "@/utils/network";
	export default {
		components: {
			CubePage,
		},
		data() {
			return {
				src: '',
				numPages: 1,
				pageTotalNum: 1,
				content: null, // 展示协议
				tabs: [], // tabs内容
				agreementType: null, // 当前协议类型
				agreementContent: [], // 协议内容
				activeName: 0, // 选中的tabs
				activeNameIndex: 0,
				// demo: [{
				// 	"title": "分销商协议2",
				// 	"image": "http://www.shop.lol/uploads/20240325/c6cf2e0e92862c77a9748bd3463deeed.pdf",
				// 	"content": "<div>\r\n<p>分销商协议2感谢您访问 <!-- -->gitee.com<!-- -->（以下简称&ldquo;本网站&rdquo;）。</p>\r\n<p>本网站由深圳市奥思网络科技有限公司（以下简称&ldquo;奥思网络&rdquo;）运行维护。本网站向公众开放，提供基于 git 的代码托管和项目管理服务。 在使用本网站前，敬请您仔细阅读以下各项使用条款（以下简称&ldquo;本使用条款&rdquo;）。您对本网站的使用(包括但不限于对本网站的访问、登录，对本网站内容的浏览和使用)，将被视为您自愿承诺接受本声明的约束。如果您对本使用条款的内容不能接受，您应当立即停止使用本网站并迅速离开。</p>\r\n<ol class=\"ml-10\">\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">本网站的使用</h4>\r\n<p>奥思网络有限许可您在您的计算机设备上浏览（使用）本网站展示的内容（由本使用条款第2条规定）。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">知识产权声明</h4>\r\n<p>本网站，包括(但不仅限于) 文字，内容，软件，录像，音乐，声音，图形，照片，图表，美术设计，图片，名称，标识，商标和/或服务标志（包括已注册和未注册的），以及其他资料（以下简称网站内容）都受到版权法，商标法和一切知识产权公约的保护。本网站内容包括奥思网络所有或控制下的内容和第三方所有或控制下，并授权奥思网络使用的内容。所有代码，文章，讨论等一切构成本网站的元素都可能是受版权保护的作品。您同意遵守所有适用本网站的版权保护法律法规，以及所有本网站包含的补充性的版权说明或限制。本网站的内容均由相应的机构/个人上传、维护。对于本站内容的任何使用请遵守内容所附带的授权协议。如不清楚相应的授权协议请询问上传该内容的机构/个人。</p>\r\n<p>任何在 <!-- -->gitee.com<!-- -->上注册的帐号上传的内容的版权均归上传者所有，上传者承担所有被上传内容的版权责任。奥思网络有权在其拥有的网站上，展示上传者上传到本网站公共区域的内容。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">个人信息的保护</h4>\r\n<p>奥思网络尊重访问本网站的任何个人的隐私信息。当您访问本网站的时候可能被要求提供您个人的基本资料(如姓名、电子邮件、电话号码等)，您可以自行选择是否提供。对于您提供的个人信息，奥思网络将根据中华人民共和国相关法律进行保密并严格保管，不会将这些信息以任何方式提供或展示给任何第三方，但下述情况除外：</p>\r\n<p>(一) 当司法机关或行政机关依照法定程序和法定职权要求本网站披露个人资料时，我们将依法提供相关资料。对于此情况下的任何披露，本网站均得免责；</p>\r\n<p>(二) 对于任何由黑客攻击、计算机病毒侵入或发作、或政府管制而造成的暂时性关闭等影响网站正常运营的不可抗力事件所造成的个人资料的泄露、丢失、被盗用或被篡改等，本网站均得免责；</p>\r\n<p>(三) 对于用户将个人密码告知他人或与他人共享注册帐号所导致的任何个人资料泄露，丢失、被盗用或被篡改等,本网站不负任何责任；</p>\r\n<p>(四) 对于与本网站链接的任何其它网站的个人资料泄露，丢失、被盗用或被篡改等事件，本网站不负任何责任。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">网站的更新与变更</h4>\r\n<p>奥思网络提供的本网站上的内容仅为方便您获取信息，奥思网络有权单方面在任何时间，对本网站的内容进行变更或更新，此种变更或更新无需以通知您或任何第三方为前提。您承认并接受上述变更或更新。我们建议您定期访问本网站以尽快获知有关的更新或变更的信息。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">无担保声明</h4>\r\n<p>在法律允许的最大限度内，本网站及本网站的内容不包括任何明确或暗示的有关（但不限于）所有权，适销性，质量满意程度，特定用途的适用性，准确性、时效性和完整性，不侵犯知识产权和其它方权利的承诺。</p>\r\n<p>奥思网络尽其合理的商业努力维护本网站的安全和功能，但不保证本网站上的所有功能正常运作，也不保证本网站连续性地或无故障运行或缺陷被及时更正。</p>\r\n<p>奥思网络不保证本网站系统适合您的电脑操作系统性能，也不保证本网站或其服务器永不产生故障或没有病毒、木马程序和其他有害程序。奥思网络亦不承担您因上述问题而产生的任何电脑的损坏的责任。</p>\r\n<p>奥思网络不为您所使用的访问本网站的网络线路和设备的可靠性以及连续性承担责任。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">禁止盗链</h4>\r\n<p>奥思网络禁止擅自利用本网站内容的网页构架系统的行为。奥思网络保留断开任何未经授权指向本网站的超文本链接或网页构架系统的权利。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">仓库大小</h4>\r\n<p>奥思网络允许用户上传仓库，规定每个仓库的大小上限为1个G，单个用户总容量为5个G (包含用户的所有仓库以及Wiki)，禁止大量的外链请求到本网站，并且不允许存放与代码无关的文件，如果代码实在有需要更大，请发邮件(git#oschina.cn)联系我们，说明使用场景和原因进行申请，我们邮件同意后方可上传更大的仓库，如果未经允许私自上传大仓库、与代码无关的文件或者大量的外链请求，奥思网络保留停止仓库的使用以及通知作者备份并删除的权利。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">成员数量</h4>\r\n<p>奥思网络允许用户创建私有仓库，规定每个私有仓库的成员数不超过5个，公开仓库不作成员限制，但成员数超过5人的公开仓库将无法转为私有仓库。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">终止使用</h4>\r\n<p>如果您的帐号违反当地相关法律法规或网站使用条款，在未经事先通知的情况下，奥思网络有权自行判断并立即终止您对本网站的使用，或者采取措施禁止您对本网站的再次访问。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">准据法和管辖权</h4>\r\n<p>本网站内容及本使用条款的解释和适用均适用中华人民共和国法律，由于使用本网站而产生的一切纠纷，除另有约定，均由中华人民共和国(奥思网络所在地)人民法院管辖。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">继续有效原则</h4>\r\n<p>如果本使用条款中的部分条款被有关机关认定为无效，则此无效部分并不影响本使用条款其他部分的效力，其他部分仍然有效。</p>\r\n</li>\r\n</ol>\r\n<h3 class=\"mt-6 text-lg font-bold text-normal\">关于我们</h3>\r\n<p>深圳市奥思网络科技有限公司（ OSCHINA ），通过社区、 Gitee 和众包等产品支持开源生态环境。</p>\r\n<p>其中， OSCHINA（oschina.net）成立于 2008 年，上线 10 余年，用户超过 600 万，是本土大型综合开源技术社区；</p>\r\n<p>Gitee（gitee.com）为代码托管&middot;协作开发平台，开发者超过 1200 万，托管项目总数超过 2800 万，汇聚几乎所有本土原创开源项目，并于 2016 年推出企业版，提供企业级代码托管服务，成为开发领域领先的 SaaS 服务提供商。</p>\r\n<p>众包（zb.oschina.net）为专注开发领域众包，累计认证开发者 5 万余人，认证企业 1 万余家。成交项目超过 7000 个，交易金额过亿元。</p>\r\n<h3 class=\"mt-6 text-lg font-bold text-normal\">联系我们</h3>\r\n<p>深圳市奥思网络科技有限公司</p>\r\n<p>地址：深圳市南山区西丽街道云科技大厦 22 楼</p>\r\n电话：0755-83170505</div>"
				// }, {
				// 	"title": "分销商协议3",
				// 	"image": "http://www.shop.lol/uploads/20240325/c6cf2e0e92862c77a9748bd3463deeed.pdf",
				// 	"content": "<div>\r\n<p>分销商协议3感谢您访问 <!-- -->gitee.com<!-- -->（以下简称&ldquo;本网站&rdquo;）。</p>\r\n<p>本网站由深圳市奥思网络科技有限公司（以下简称&ldquo;奥思网络&rdquo;）运行维护。本网站向公众开放，提供基于 git 的代码托管和项目管理服务。 在使用本网站前，敬请您仔细阅读以下各项使用条款（以下简称&ldquo;本使用条款&rdquo;）。您对本网站的使用(包括但不限于对本网站的访问、登录，对本网站内容的浏览和使用)，将被视为您自愿承诺接受本声明的约束。如果您对本使用条款的内容不能接受，您应当立即停止使用本网站并迅速离开。</p>\r\n<ol class=\"ml-10\">\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">本网站的使用</h4>\r\n<p>奥思网络有限许可您在您的计算机设备上浏览（使用）本网站展示的内容（由本使用条款第2条规定）。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">知识产权声明</h4>\r\n<p>本网站，包括(但不仅限于) 文字，内容，软件，录像，音乐，声音，图形，照片，图表，美术设计，图片，名称，标识，商标和/或服务标志（包括已注册和未注册的），以及其他资料（以下简称网站内容）都受到版权法，商标法和一切知识产权公约的保护。本网站内容包括奥思网络所有或控制下的内容和第三方所有或控制下，并授权奥思网络使用的内容。所有代码，文章，讨论等一切构成本网站的元素都可能是受版权保护的作品。您同意遵守所有适用本网站的版权保护法律法规，以及所有本网站包含的补充性的版权说明或限制。本网站的内容均由相应的机构/个人上传、维护。对于本站内容的任何使用请遵守内容所附带的授权协议。如不清楚相应的授权协议请询问上传该内容的机构/个人。</p>\r\n<p>任何在 <!-- -->gitee.com<!-- -->上注册的帐号上传的内容的版权均归上传者所有，上传者承担所有被上传内容的版权责任。奥思网络有权在其拥有的网站上，展示上传者上传到本网站公共区域的内容。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">个人信息的保护</h4>\r\n<p>奥思网络尊重访问本网站的任何个人的隐私信息。当您访问本网站的时候可能被要求提供您个人的基本资料(如姓名、电子邮件、电话号码等)，您可以自行选择是否提供。对于您提供的个人信息，奥思网络将根据中华人民共和国相关法律进行保密并严格保管，不会将这些信息以任何方式提供或展示给任何第三方，但下述情况除外：</p>\r\n<p>(一) 当司法机关或行政机关依照法定程序和法定职权要求本网站披露个人资料时，我们将依法提供相关资料。对于此情况下的任何披露，本网站均得免责；</p>\r\n<p>(二) 对于任何由黑客攻击、计算机病毒侵入或发作、或政府管制而造成的暂时性关闭等影响网站正常运营的不可抗力事件所造成的个人资料的泄露、丢失、被盗用或被篡改等，本网站均得免责；</p>\r\n<p>(三) 对于用户将个人密码告知他人或与他人共享注册帐号所导致的任何个人资料泄露，丢失、被盗用或被篡改等,本网站不负任何责任；</p>\r\n<p>(四) 对于与本网站链接的任何其它网站的个人资料泄露，丢失、被盗用或被篡改等事件，本网站不负任何责任。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">网站的更新与变更</h4>\r\n<p>奥思网络提供的本网站上的内容仅为方便您获取信息，奥思网络有权单方面在任何时间，对本网站的内容进行变更或更新，此种变更或更新无需以通知您或任何第三方为前提。您承认并接受上述变更或更新。我们建议您定期访问本网站以尽快获知有关的更新或变更的信息。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">无担保声明</h4>\r\n<p>在法律允许的最大限度内，本网站及本网站的内容不包括任何明确或暗示的有关（但不限于）所有权，适销性，质量满意程度，特定用途的适用性，准确性、时效性和完整性，不侵犯知识产权和其它方权利的承诺。</p>\r\n<p>奥思网络尽其合理的商业努力维护本网站的安全和功能，但不保证本网站上的所有功能正常运作，也不保证本网站连续性地或无故障运行或缺陷被及时更正。</p>\r\n<p>奥思网络不保证本网站系统适合您的电脑操作系统性能，也不保证本网站或其服务器永不产生故障或没有病毒、木马程序和其他有害程序。奥思网络亦不承担您因上述问题而产生的任何电脑的损坏的责任。</p>\r\n<p>奥思网络不为您所使用的访问本网站的网络线路和设备的可靠性以及连续性承担责任。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">禁止盗链</h4>\r\n<p>奥思网络禁止擅自利用本网站内容的网页构架系统的行为。奥思网络保留断开任何未经授权指向本网站的超文本链接或网页构架系统的权利。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">仓库大小</h4>\r\n<p>奥思网络允许用户上传仓库，规定每个仓库的大小上限为1个G，单个用户总容量为5个G (包含用户的所有仓库以及Wiki)，禁止大量的外链请求到本网站，并且不允许存放与代码无关的文件，如果代码实在有需要更大，请发邮件(git#oschina.cn)联系我们，说明使用场景和原因进行申请，我们邮件同意后方可上传更大的仓库，如果未经允许私自上传大仓库、与代码无关的文件或者大量的外链请求，奥思网络保留停止仓库的使用以及通知作者备份并删除的权利。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">成员数量</h4>\r\n<p>奥思网络允许用户创建私有仓库，规定每个私有仓库的成员数不超过5个，公开仓库不作成员限制，但成员数超过5人的公开仓库将无法转为私有仓库。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">终止使用</h4>\r\n<p>如果您的帐号违反当地相关法律法规或网站使用条款，在未经事先通知的情况下，奥思网络有权自行判断并立即终止您对本网站的使用，或者采取措施禁止您对本网站的再次访问。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">准据法和管辖权</h4>\r\n<p>本网站内容及本使用条款的解释和适用均适用中华人民共和国法律，由于使用本网站而产生的一切纠纷，除另有约定，均由中华人民共和国(奥思网络所在地)人民法院管辖。</p>\r\n</li>\r\n<li class=\"list-decimal\">\r\n<h4 class=\"font-bold text-normal\">继续有效原则</h4>\r\n<p>如果本使用条款中的部分条款被有关机关认定为无效，则此无效部分并不影响本使用条款其他部分的效力，其他部分仍然有效。</p>\r\n</li>\r\n</ol>\r\n<h3 class=\"mt-6 text-lg font-bold text-normal\">关于我们</h3>\r\n<p>深圳市奥思网络科技有限公司（ OSCHINA ），通过社区、 Gitee 和众包等产品支持开源生态环境。</p>\r\n<p>其中， OSCHINA（oschina.net）成立于 2008 年，上线 10 余年，用户超过 600 万，是本土大型综合开源技术社区；</p>\r\n<p>Gitee（gitee.com）为代码托管&middot;协作开发平台，开发者超过 1200 万，托管项目总数超过 2800 万，汇聚几乎所有本土原创开源项目，并于 2016 年推出企业版，提供企业级代码托管服务，成为开发领域领先的 SaaS 服务提供商。</p>\r\n<p>众包（zb.oschina.net）为专注开发领域众包，累计认证开发者 5 万余人，认证企业 1 万余家。成交项目超过 7000 个，交易金额过亿元。</p>\r\n<h3 class=\"mt-6 text-lg font-bold text-normal\">联系我们</h3>\r\n<p>深圳市奥思网络科技有限公司</p>\r\n<p>地址：深圳市南山区西丽街道云科技大厦 22 楼</p>\r\n电话：0755-83170505</div>"
				// }]
			}
		},
		mounted() {
			//this.getData('90');
			let query = this.$route.query;
			console.log(query)
			let obj = {}
			if (query.place == '102') {
				obj = {
					name: '102',
					title: '分销商协议',
					url: '/addons/litestore/api.distributor/signing'
				}
			}
			if (query.place == '101') {
				obj = {
					name: '101',
					title: '店铺协议',
					url: '/addons/litestore/api.store/signing'
				}
			}
      if (query.place == '110') {
        obj = {
          name: '110',
          title: '导游协议',
          url: '/addons/litestore/api.guide/signing'
        }
      }
			this.agreementType = obj;
			this.getData(obj)
			//this.tabs.push(obj)
		},
		methods: {
			//获取角色协议列表
			getData(obj) {
				var url = "/addons/litestore/api.account/getUserAgreement"
				//这里直接调用网络接口
				let params = {
					place: obj.name
				}
				util.get(url, params, res => {
					if (res.code == 1) {
						let addobj = {};
						//let newdata = res.data.concat(this.demo);
						res.data.forEach((x, i) => {
							addobj = {
								name: i,
								title: x.title
							}
							x.name = i
							this.tabs.push(addobj)
						})
						this.agreementContent = res.data
						let data = res.data[0];
						this.content = data;
					}
				})
			},
			// 点击切换协议内容
			onClick(name) {
				if (this.activeNameIndex == name) return;
				this.activeNameIndex = name;
				let newdata = this.agreementContent[name]
				this.content = newdata
			},
			// 下载pdf
			downloadPdf() {
				if (!this.content.image) {
					return;
				}
				let url = window.URL.createObjectURL(new Blob([this.content.image]));
				let link = document.createElement('a');
				link.style.display = 'none';
				link.href = url;
				link.setAttribute('download', '协议下载' + '.pdf');
				document.body.appendChild(link);
				link.click();
			},
			// 同意阅读协议操作
			agreement() {
				var url = this.agreementType.url;
				util.post(url, {}, res => {
          this.$toast.success(res.msg);

          if (res.code == 1) {
            setTimeout(() => {
							//this.$router.go(-1); // 返回上一页
              redirect(res.data);
						}, 1000)
					}
				})
			},
		}
	}
</script>
<style type="text/css" lang="less">
	.main {
		.content {
			padding: 20px 20px 200px;
			text-align: center;
		}

		.yes {
			text-align: left;
		}

		.down {
			position: fixed;
			bottom: 140px;
			left: 0;
			width: 100%;

			button {
				width: 90%;
				margin: 0 auto;
				border-radius: 8px;
			}
		}

		.agreement {
			bottom: 80px
		}
	}
</style>
